
<template>
  <v-scale-transition>
    <panel
      :title="title"
      :breadcrumbs="breadcrumbs"
    >
      <v-toolbar
        card
        extended
      >
        <v-container fluid>
          <v-layout row>
            <v-flex xs3>
              <v-select
                v-model="filter"
                :items="filters"
                item-text="text"
                item-value="value"
                label="Filter by"
              />
            </v-flex>
            <v-flex xs5>
              <v-text-field
                v-if="filter !== null"
                v-model="search"
                label="Enter search string"
                clearable
              />
            </v-flex>
            <v-card-actions>
              <v-spacer />
              <v-btn
                v-if="filter !== null"
                color="primary"
                dark
                class="mb-2"
                @click="refreshList()"
              >
                Search
              </v-btn>
            </v-card-actions>
            <v-flex xs1>
              <v-spacer />
              <v-checkbox
                v-model="xox"
                label="XOX"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="items"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :rows-per-page-items="[10, 25, 50, 100]"
            :expand="true"
            class="px-1 pb-1"
          >
            <template #items="props">
              <tr @click="props.expanded = !props.expanded">
                <td
                  v-if="props.item.pushupdate"
                  class="text-xs-left"
                >
                  {{ props.item.pushupdate }}
                </td>
                <td
                  v-else
                  class="text-xs-left"
                >
                  -
                </td>
                <td
                  v-if="props.item.msisdn"
                  class="text-xs-left"
                >
                  {{ props.item.msisdn }}
                </td>
                <td
                  v-else
                  class="text-xs-left"
                >
                  -
                </td>
                <td
                  v-if="props.item.old"
                  class="text-xs-left"
                >
                  {{ props.item.old }}
                </td>
                <td
                  v-else
                  class="text-xs-left"
                >
                  -
                </td>
                <td
                  v-if="props.item.new"
                  class="text-xs-left"
                >
                  {{ props.item.new }}
                </td>
                <td
                  v-else
                  class="text-xs-left"
                >
                  -
                </td>
                <td
                  v-if="props.item.reason"
                  class="text-xs-center"
                >
                  {{ props.item.reason }}
                </td>
                <td
                  v-else
                  class="text-xs-center"
                >
                  -
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <v-alert
                :value="true"
                :type="error ? 'error' : 'info'"
              >
                {{ noDataText }}
              </v-alert>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </panel>
  </v-scale-transition>
</template>

<script>
import { createGetParams } from '@/rest'
import security from '@/security'
// import Jimp from 'jimp'

const pageTitle = 'User List'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "panel" */ '@/components/Panel'),
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'DMT Kits', disabled: false, to: '/support/dmt_kits',
        },
        {
          text: pageTitle, disabled: true,
        },
      ],
      activeItem: null,
      alert: false,
      alertType: null,
      alertMessage: null,
      xox: null,
      error: null,
      filter: null,
      filters: [
        {
          text: 'Msisdn',
          value: 'msisdn',
        },
        {
          text: 'Old Dealer',
          value: 'old',
        },
        {
          text: 'New Dealer',
          value: 'new',
        },
      ],
      headers: [
        {
          align: 'left',
          sortable: false,
          text: 'Date',
          value: 'pushupdate',
        },
        {
          align: 'left',
          sortable: false,
          text: 'Msisdn',
          value: 'msisdn',
        },
        {
          align: 'left',
          sortable: false,
          text: 'Old Dealer',
          value: 'old',
        },
        {
          align: 'left',
          sortable: false,
          text: 'New Dealer',
          value: 'new',
        },
        {
          align: 'center',
          sortable: false,
          text: 'Reason',
          value: 'reason',
        },
      ],
      items: [],
      onex: true,
      loading: false,
      pagination: {},
      snackbar: false,
      snackbarMessage: null,
      search: null,
      searchId: null,
      source: null,
      title: pageTitle,
      totalItems: 0,
    }
  },
  computed: {
    noDataText: function () {
      return this.error ? this.error : "There's nothing to display."
    },
  },
  watch: {
    xox: function (val) {
      this.onex = !val
    },
    filter: function () {
      (this.search) && this.resetList()
    },
    pagination: {
      handler () {
        this.refreshList()
      },
      deep: true,
    },
  },
  mounted: function () {
    this.xox = security.me.claimer() === 'xox'
  },
  methods: {
    async getUserList () {
      const filters = this.getFilters()
      if (!filters) return { items: [], totalItems: 0 }
      this.loading = true
      const { page, rowsPerPage } = this.pagination
      const parameters = {
        page,
        rowsPerPage,
      }
      Object.assign(parameters, filters)

      const apiParameters = createGetParams(parameters)
      try {
        this.source = this.$rest.CancelToken.source()
        Object.assign(apiParameters, { cancelToken: this.source.token })
        const response = await this.$rest.get('getpushupUser.php', apiParameters)
        this.error = null
        this.loading = false
        return response.data
      } catch (error) {
        if (!this.$rest.isCancel(error)) {
          this.error = error.message
        }
        return { items: [], totalItems: 0 }
      }
    },
    getFilters () {
      const filterBy = {}

      if (this.filter === 'msisdn' && this.search) {
        Object.assign(filterBy, { msisdn: this.search })
      }

      if (this.filter === 'old' && this.search) {
        Object.assign(filterBy, { old: this.search })
      }

      if (this.filter === 'new' && this.search) {
        Object.assign(filterBy, { new: this.search })
      }

      Object.assign(filterBy, { onex: this.onex })

      return this.filter && (this.search) ? filterBy : null
    },
    cancelRequest: function () {
      if (this.source) {
        this.source.cancel('Forced cancellation.')
        this.source = null
      }
    },
    refreshList () {
      this.getUserList().then(data => {
        this.items = data.items
        this.totalItems = data.totalItems
      })
    },
    resetList () {
      this.items = []
      this.totalItems = 0
    },
    showError (message) {
      this.alertType = 'error'
      this.alertMessage = message
      this.alert = true
    },
  },
}
</script>
